import { createContext, useContext, useEffect, useState } from 'react';
import axiosInstance from '../interceptor/axiosInstance';

const AppContext = createContext();

export const GlobalStateProvider = ({ children }) => {
  const [ alert, setAlert] = useState('');
  const [ userId, setUserId ] = useState(localStorage.getItem("userId"))
  const [ rightsList, setRightsList ] = useState([])
  useEffect(() => {
    axiosInstance
      .get(`individual_analytics/users/${userId}/`)
      .then(res => {
        setRightsList(res.data.data.access)
      })
      .catch(error => {
        setRightsList(null)
      })
  }, [userId])

  return (
    <AppContext.Provider
      value={{
        alert,
        setAlert,
        userId,
        setUserId,
        // plantList,
        rightsList,
        // userData,
        // setUserData
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useGlobalStateContext = () => useContext(AppContext);
